module.exports = __webpack_public_path__ + "media/images/top/rank3-46265a1d1d931c24c3f06c8ed26993c0.gif";